import { render, staticRenderFns } from "./SedesLinkedCompanies.vue?vue&type=template&id=433f0a07&scoped=true"
import script from "./SedesLinkedCompanies.vue?vue&type=script&lang=js"
export * from "./SedesLinkedCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f0a07",
  null
  
)

export default component.exports